import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const KycOfakimStatus = (props) => {
    return (
        <ModalComponent isVerticalCentered canCloseModal={false}>
            <InfoPage
                insideModalComponent
                iconName={props.status !== 'fail' ? 'clock-80' : ''}
                iconColor={props.status !== 'fail' ? 'primary' : ''}
                animatedIconFail={props.status === 'fail'}
                headerText={<DangerouslyHtml dangerouslyHtml={props.screenTitle} />}
                secondaryText={props.renderText()}
                primaryButtonCaption={props.gotItButton}
                primaryButtonOnClick={props.onClick}
            />
        </ModalComponent>
    );
};

export default KycOfakimStatus;
